export const NSI = 'nsi';

export const NSI_ACTIONS_NAME = {
  getNsiCountryWithData: `${NSI}/getNsiCountryWithData`,
  getNsiBusinessTipsStatus: `${NSI}/getNsiBusinessTipsStatus`,
} as const;

export const NSI_MUTATIONS_NAME = {
  setNsiCountryWithData: 'setNsiCountryWithData',
  setNsiBusinessTipsStatusList: 'setNsiBusinessTipsStatusList',
} as const;

export const NSI_GETTERS_NAME = {
  getNsiCountryListWithData: `${NSI}/getNsiCountryListWithData`,
  getNsiBusinessTipsStatusList: `${NSI}/getNsiBusinessTipsStatusList`,
} as const;
